// source: mti/store/core_iii/core_iii_port_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var mti_store_cable_state_pb = require('../../../mti/store/cable/state_pb.js');
goog.object.extend(proto, mti_store_cable_state_pb);
goog.exportSymbol('proto.mti.store.core_iii.CoreIIIPortStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mti.store.core_iii.CoreIIIPortStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mti.store.core_iii.CoreIIIPortStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mti.store.core_iii.CoreIIIPortStatus.displayName = 'proto.mti.store.core_iii.CoreIIIPortStatus';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.mti.store.core_iii.CoreIIIPortStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mti.store.core_iii.CoreIIIPortStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.core_iii.CoreIIIPortStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    primaryDeviceConnected: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    secondaryDeviceConnected: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    charging: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    armed: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    primaryDeviceAlarming: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    secondaryDeviceAlarming: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    overCurrent: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    lifted: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    cableType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    cableSerialNumber: jspb.Message.getFieldWithDefault(msg, 10, ""),
    cableModelNumber: jspb.Message.getFieldWithDefault(msg, 11, ""),
    cableVersion: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mti.store.core_iii.CoreIIIPortStatus;
  return proto.mti.store.core_iii.CoreIIIPortStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mti.store.core_iii.CoreIIIPortStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPrimaryDeviceConnected(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSecondaryDeviceConnected(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCharging(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArmed(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPrimaryDeviceAlarming(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSecondaryDeviceAlarming(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverCurrent(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLifted(value);
      break;
    case 9:
      var value = /** @type {!proto.mti.store.cable.CableType} */ (reader.readEnum());
      msg.setCableType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCableSerialNumber(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCableModelNumber(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCableVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mti.store.core_iii.CoreIIIPortStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mti.store.core_iii.CoreIIIPortStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.core_iii.CoreIIIPortStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimaryDeviceConnected();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSecondaryDeviceConnected();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCharging();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getArmed();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPrimaryDeviceAlarming();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getSecondaryDeviceAlarming();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getOverCurrent();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getLifted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCableType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getCableSerialNumber();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCableModelNumber();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCableVersion();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional bool primary_device_connected = 1;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getPrimaryDeviceConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setPrimaryDeviceConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool secondary_device_connected = 2;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getSecondaryDeviceConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setSecondaryDeviceConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool charging = 3;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCharging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCharging = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool armed = 4;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getArmed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setArmed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool primary_device_alarming = 5;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getPrimaryDeviceAlarming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setPrimaryDeviceAlarming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool secondary_device_alarming = 6;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getSecondaryDeviceAlarming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setSecondaryDeviceAlarming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool over_current = 7;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getOverCurrent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setOverCurrent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool lifted = 8;
 * @return {boolean}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getLifted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setLifted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional mti.store.cable.CableType cable_type = 9;
 * @return {!proto.mti.store.cable.CableType}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableType = function() {
  return /** @type {!proto.mti.store.cable.CableType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.mti.store.cable.CableType} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string cable_serial_number = 10;
 * @return {string}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableSerialNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableSerialNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string cable_model_number = 11;
 * @return {string}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableModelNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableModelNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string cable_version = 12;
 * @return {string}
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.core_iii.CoreIIIPortStatus} returns this
 */
proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


goog.object.extend(exports, proto.mti.store.core_iii);
